import PartyLedgerList from "./PartyLedgerList";

export default PartyLedgerList;
